import { Store } from 'redux'

import { importDependency } from 'core-components/helpers'
import { IAppStoreRemoteReducers } from 'src/core/components/app/models/IAppStore'

import hpscmReducer from './hpscmSlice'

export const hpscmRemoteReducers: IAppStoreRemoteReducers[] = [
  {
    key: 'pf',
    initReducer: async () => {
      return importDependency(
        'pf/pfReducer',
        () => import('pf/pfReducer'),
        (data) => data.reducer
      )
    },
    initMiddleware: async () => {
      return await importDependency(
        'pf/pfReducer',
        () => import('pf/pfReducer'),
        (data) => data.middleware
      )
    },
    initStoreSetter: async () => {
      const storeSetter = await importDependency(
        'pf/pfReducer',
        () => import('pf/pfReducer'),
        (data) => data.setPFStore
      )
      return (applicationStore: Store) => {
        if (storeSetter) {
          storeSetter(applicationStore)
        }
      }
    },
  },
  {
    key: 'remoteOrgchart',
    initReducer: async () => {
      return importDependency(
        'remoteOrgchart/orgchartReducer',
        () => import('remoteOrgchart/orgchartReducer'),
        (data) => {
          return data.reducer
        }
      )
    },
  },
  {
    key: 'remoteKbase',
    initReducer: async () => {
      return importDependency(
        'remoteKbase/kbaseReducer',
        () => import('remoteKbase/kbaseReducer'),
        (data) => {
          return data.reducer
        }
      )
    },
  },
  {
    key: 'remoteDocflow',
    initReducer: async () => {
      return importDependency(
        'remoteDocflow/docflowReducer',
        () => import('remoteDocflow/docflowReducer'),
        (data) => {
          return data.reducer
        }
      )
    },
  },
]

export const hpscmProjectReducer = {
  hpscm: hpscmReducer,
}
